import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import UnderRow from './UnderRow';
import { STATUSES, TTypeEnum } from '../consts';

const UnderRowLogic = ({ domain, isCNameError, status = STATUSES.LIVE, className = '' }) => {
    const getUnderRowProps = () => {
        switch (status) {
            case STATUSES.PENDING_CNAME:
                return {
                    type: isCNameError ? TTypeEnum.ERROR : TTypeEnum.INFO,
                    showAlert: !!isCNameError,
                    status: STATUSES.PENDING_CNAME,
                    showSDKInstructions: false,
                    domain,
                };
            case STATUSES.PENDING_CERTIFICATE:
                return {
                    type: TTypeEnum.INFO,
                    status: STATUSES.PENDING_CERTIFICATE,
                    showSDKInstructions: true,
                    domain,
                };
            case STATUSES.ERROR:
                return {
                    type: TTypeEnum.ERROR,
                    status: STATUSES.ERROR,
                    showSDKInstructions: false,
                    message: 'ERROR',
                };
            default:
                return {
                    type: TTypeEnum.INFO,
                    message: null,
                    showSDKInstructions: false,
                    domain,
                };
        }
    };

    const underRowProps = getUnderRowProps();

    return (
        <UnderRow
            type={underRowProps.type}
            message={underRowProps.message}
            domain={underRowProps.domain}
            showSDKInstructions={underRowProps.showSDKInstructions}
            className={className}
            status={underRowProps.status}
            showAlert={underRowProps.showAlert}
        />
    );
};

UnderRowLogic.propTypes = {
    domain: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(STATUSES)),
    className: PropTypes.string,
    isCNameError: PropTypes.bool,
};

export default withLocalize(UnderRowLogic);
